import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  CSSTransition,
  TransitionGroup
} from 'react-transition-group';

import offer from 'src/types/offer';
import styles from 'src/components/Offers.scss';
import Offer from 'src/components/Offer';


class Offers extends PureComponent {
  getJobLink = (offerAbsoluteUri, sug) => `${offerAbsoluteUri}?sug=${sug}`;

  render() {
    const { offers, remove, toggleFavourite } = this.props;
    return (
      <TransitionGroup component={ null }>
        {
          offers
            .map(({
              offerId,
              jobTitle,
              regionName,
              countryName,
              workplace,
              companyLogoUri,
              offerAbsoluteUri,
              companyName,
              sug,
              isFavourite,
              isOneClickApply,
              isRemoteRecruitment,
              isSuperOffer
            }) => (
              <CSSTransition
                key={ offerId }
                classNames={ {
                  exitActive: `${styles.offer} ${styles['offer--exit-active']}`,
                  exited: `${styles.offer} ${styles['offer--exited']}`
                } }
                timeout={ 300 }
              >
                <Offer
                  company={ companyName }
                  id={ offerId }
                  isFavourite={ isFavourite }
                  isOneClickApply={ isOneClickApply }
                  isRemoteRecruitment={ isRemoteRecruitment }
                  isSuperOffer={ isSuperOffer }
                  jobLink={ this.getJobLink(offerAbsoluteUri, sug) }
                  jobTitle={ jobTitle }
                  location={ workplace || regionName || countryName }
                  logo={ companyLogoUri }
                  remove={ remove }
                  toggleFavourite={ toggleFavourite }
                />
              </CSSTransition>
            ))
        }
      </TransitionGroup>
    );
  }
}


Offers.propTypes = {
  offers: PropTypes.arrayOf(offer).isRequired,
  remove: PropTypes.func.isRequired,
  toggleFavourite: PropTypes.func.isRequired
};

export default Offers;
